export default class Customer {
    constructor(json) {
        json = json || {};
        this.identifier = json.identifier || '';
        this.contact_id = json.contact_id || '';
        this.first_name = json.first_name || '';
        this.last_name = json.last_name || '';
        this.email = json.email || '';
        this.phone = json.phone_number ? json.phone : '';
    }

    set(first_name = '', last_name = '', email = '', phone = '') {
        if (first_name || last_name || email || phone) {
            this.first_name = first_name;
            this.last_name = last_name;
            this.email = email;
            this.phone = phone;
        }
    }

    get fullName() {
        if (this.last_name || this.first_name) {
            return ((this.last_name || '') + ' ' + (this.first_name || '')).trim()
        } else {
            return 'Anonymous'
        }
    }
}